/**
 * Picks v2 or v1 of the Category edit page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CategoryAddEditPage   from './CategoryAddEditPage';
import CategoryAddEditPageV2 from './CategoryAddEditPageV2';

export default function CategoryAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CategoryAddEditPageV2 : CategoryAddEditPage;
  return <Component {...props} />;
}
